// @ts-nocheck

import * as Types from '../../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type DeleteCustomObjectMutationVariables = Types.Exact<{
  uid: Types.Scalars['String']['input'];
}>;

export type DeleteCustomObjectMutation = { deleteCustomObject?: boolean | null };

export const DeleteCustomObjectDocument = gql`
    mutation DeleteCustomObject($uid: String!) {
  deleteCustomObject(uid: $uid)
}
    ` as unknown as DocumentNode<DeleteCustomObjectMutation, DeleteCustomObjectMutationVariables>;
